var e=function(e){return"Serie--name-"+e.name+"--x-"+e.fieldName.x+"--y-"+e.fieldName.y};export{e as makeSerieId};
